import template from './foodBenefitManager.html';
import controller from './foodBenefitManager.controller';
import './foodBenefitManager.scss';

let foodBenefitManagerComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default foodBenefitManagerComponent;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/features/foodBenefitManager/foodBenefitManager.component.js